import ClassroomRoute from './ClassroomRoute';
import ClassroomLoading from './ClassroomLoading';

export { ClassroomLoading };
export default ClassroomRoute;
